//return true if value equals undefined, null or ""
export const isEmpty = (value:any):boolean => {
    return value === undefined || value === null || value === '';
};
